var base = require('settings/security');

Vue.component('spark-security', {
    mixins: [base],
    data(){
        return{
            two_factor_auth_modal: false
        };
    },

    /**
     * The component has been created by Vue.
     */
    created() {
        var self = this;

        this.$on('receivedTwoFactorResetCode', function (code) {
            self.twoFactorResetCode = code;

            //$('#modal-show-two-factor-reset-code').modal('show');
            self.two_factor_auth_modal = true;
        });
    }
});
